'use strict';

/*
    TrayModal
    A modal container that is loaded into the tray. The nav and main content area is grayed out. An "X" in the top-left
    corner closes the modal and loads the route specified by the `href` property.
    This component is intended to be extended by specific pages and not implemented directly.
    JS initialization:
        function MyProductModal () {
            this.extends = [_TrayModal, _ProductController];
    Arguments:
        showCloseButton (optional) [boolean]:
            Defaults to true. Show an "X" that, when clicked, will redirect to the route specified by href.
        href (optional) [string]:
            Defaults to the main dashboard. The url that should be loaded when the close button is clicked.
        displayType (optional) [string]:
            Defaults to "flex". The value of the display css property to be assigned to this.node when the page is ready.
        parentComponent (optional) [string]:
            Name of the reference of the page component in the mogo repository (mogo.registry.mogoUI.repo) that
            corresponds to the url that should be loaded when the close button is clicked. Should implement a
            _pushAnalytics() method. If this is not specified or the component doesn't exist in the repository,
            the this._pushCloseAnalytics() method is called instead. When extending this component, implement
            your own version of this method.
    Methods (see methods for additional usage):
        destroy()
*/

function _TrayModal() {
  this.extends = [_AnalyticsData];
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.analytics = new Analytics();

  this.href = '/member/dashboard/home';
  this.showCloseButton = true;
  this.closeLink = null;
  this.displayType = 'flex';
  this.parentComponent = null;
  this._history = null;
  // this Id can be override at page level if we want to send specific analytics id
  this._closeTrayEventAnalyticsId = 'Member-Navigation-Close-Navigation-Component';
  this._closeButtenClicked = false;

  this.el = {};
  this._classes = {
    closeBtn: 'js--tray-modal-close',
    backBtn: 'js--tray-back-btn'
  };

  this.init = function () {
    this.el.backBtn = this.node.querySelector('.' + this._classes.backBtn);

    this._connectionIssueConfig = {
      view: '/member/connection-error',
      node: this.node.lastChild,
      isEntirePage: false
    };
    this._history = new History();
    this.analytics.pushEvent('virtual-page-view');
  };

  this.initAllReady = function () {
    var _this = this;

    document.querySelector('.portal__primary').scrollTop = 0;

    // add close button as first child of this node
    if (this.showCloseButton) {
      this.closeLink = document.createElement('a');
      this.closeLink.addClass('tray-modal-close');
      this.closeLink.addClass(this._classes.closeBtn);

      this.closeLink.innerHTML = "<svg class='svg-icon'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#icon-close2'/></svg>";
      this.node.insertBefore(this.closeLink, this.node.firstChild);

      this.closeLink.addEventListener('click', function (e) {
        _this._closeButtenClicked = true;
        _this._pushCloseAnalytics();
        // this is a terrible place to put this code but we currently have no way to delay code from executing when
        // the modal is disposed (and _TrayModal has no presenter object ref)
        if (typeof mogo.registry.mogoUI.repo.Portal.presenter.onModalClose === 'function') {
          mogo.registry.mogoUI.repo.Portal.presenter.onModalClose();
          delete mogo.registry.mogoUI.repo.Portal.presenter.onModalClose;
        }
      });

      // IE11 hard refresh on close of tray modal
      if ($('html.ie11').length === 0) {
        this._history.addHistoryNode(this.closeLink, this.href);
      } else {
        $(this.closeLink).attr('href', this.href);
      }
    }

    this.node.style.display = this.displayType;
  };

  this.destroy = function () {
    if (this._closeButtenClicked) {
      this.pushCloseTrayModalAnalytics();
    }
  };

  this.disableClick = function (e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  };

  this.setDisabledState = function () {
    this.closeLink.addEventListener('click', this.disableClick, true);
    this.el.backBtn.addEventListener('click', this.disableClick, true);
  };

  this.removeDisabledState = function () {
    this.closeLink.removeEventListener('click', this.disableClick, true);
    this.el.backBtn.removeEventListener('click', this.disableClick, true);
  };

  this._pushCloseAnalytics = function () {};

  this.pushCloseTrayModalAnalytics = function () {
    // default event for modal close
    // (typically replaced with product-specific version in extending component)
    this.analytics.forcePushEvent('generic-member-navigation', {
      memberNavigation: [this._closeTrayEventAnalyticsId]
    });
  };
}